import { render } from "./itemReport.vue?vue&type=template&id=646d8f47"
import script from "./itemReport.vue?vue&type=script&lang=js"
export * from "./itemReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__